import './ModalActionButtons.scss';
import React from 'react';
import Button from '../button/Button';
import { useTranslation } from 'react-i18next';

type ModalActionButtonsProps = {
    disabled?: boolean;
    isLoading?: boolean;
    localeAction?: string;
    localeCancel?: string;
    onAction?: () => void;
    onCancel?: () => void;
};

const ModalActionButtons = ({
    disabled,
    isLoading,
    localeAction,
    localeCancel,
    onAction,
    onCancel
}: ModalActionButtonsProps) => {
    const { t } = useTranslation();

    return (
        <div className="b-modal-action-buttons">
            {onCancel && (
                <Button
                    secondaryButton
                    extraClass=""
                    text={localeCancel ? t(localeCancel) : t('cancel')}
                    authButton={false}
                    clickHandler={onCancel}
                    disabled={isLoading}
                    name={localeCancel ? t(localeCancel).toLowerCase() : t('cancel').toLowerCase()}
                />
            )}
            {onAction && (
                <Button
                    extraClass=""
                    text={localeAction ? t(localeAction) : t('save')}
                    authButton={false}
                    clickHandler={onAction}
                    disabled={disabled}
                    isLoading={isLoading}
                    name={localeAction ? t(localeAction).toLowerCase() : t('save').toLowerCase()}
                />
            )}
        </div>
    );
};

export default ModalActionButtons;
